import tooltipDirective from '~/directives/Tooltip';
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('tooltip', {
        beforeMount(el, binding) {
            tooltipDirective.beforeMount(el, binding);
        },
        updated(el, binding) {
            tooltipDirective.updated(el, binding);
        },
        unmounted(el) {
            tooltipDirective.unmounted(el);
        },
    });
});
